<template>
  <div class="h-mx-auto min-h-screen">
    <router-view />
  </div>
</template>
  
<script setup> 
  
</script>
